import React, { useEffect } from "react";
import "./terms.css";
import NavBar from "../components/Nav";
import Footer from "../components/footer";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <NavBar />

      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero-content">
          <h1 className="terms-hero-title">Terms and Conditions</h1>
          <p className="terms-hero-subtitle">
            Please read these terms carefully before using our website or
            services. By continuing to browse, you agree to comply with the
            following terms and conditions.
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="terms-container">
        <section className="terms-section">
          <div className="terms-content">
            <p>
              • It is crucial to carefully review these terms of use before
              engaging in any activities on this site.
            </p>
            <p>
              • By accessing this website, you acknowledge that you accept and
              agree to comply with these Terms and Conditions, as well as all
              applicable laws and regulations.
            </p>
            <p>
              • All materials, including text, images, and code, found on this
              site are protected by copyright and trademark laws.
            </p>
            <p>
              • Easy Tax Experts reserves the right to modify or update these
              terms as necessary, without prior notice.
            </p>

            <h2 className="terms-title">Privacy Policy</h2>
            <p>
              • Easy Tax Experts, a full-service tax consulting firm, offers a
              variety of services such as tax return preparation, planning,
              compliance, bookkeeping, business advisory, and more.
            </p>
            <p>
              • We prioritize customer confidentiality and are committed to
              protecting shared data.
            </p>
            <p>
              • Under no circumstances shall Easy Tax Experts or its employees
              be held liable for damages arising from the use of our services.
            </p>

            <h2 className="terms-title">Cookies</h2>
            <p>
              • Cookies help us improve your browsing experience. You may accept
              or reject cookies in your browser settings.
            </p>

            <h2 className="terms-title">Security</h2>
            <p>
              • We implement industry-standard measures to safeguard your data
              from unauthorized access or misuse.
            </p>

            <h2 className="terms-title">Data Protection & Integrity</h2>
            <p>
              • We maintain strict data protection policies and retain personal
              information only as long as necessary for our services.
            </p>

            <h2 className="terms-title">Unsuitable Content</h2>
            <p>
              • Users are prohibited from uploading, downloading, or sharing
              offensive or unlawful content.
            </p>

            <h2 className="terms-title">Intellectual Property Laws</h2>
            <p>
              • All content on this site is owned by Easy Tax Experts and
              protected under copyright laws.
            </p>

            <h2 className="terms-title">Copyrights</h2>
            <p>
              • All visual and textual content on this website is the exclusive
              property of Easy Tax Experts.
            </p>

            <h2 className="terms-title">Disclosure</h2>
            <p>
              • Information collected via this website is used to enhance user
              experience. Refer to our Privacy Policy for more details.
            </p>

            <h2 className="terms-title">Return Policy</h2>
            <p>
              • Fees for services are non-refundable, except in cases where the
              promised service was not delivered. Contact{" "}
              <a href="mailto:info@easytaxexperts.com">
                info@easytaxexperts.com
              </a>{" "}
              for refund queries.
            </p>

            <h2 className="terms-title">Consent Form Disclosure</h2>
            <p>
              • As required by federal law, this consent form outlines our
              policy on sharing tax return information. Consent allows sharing
              only for legitimate preparation purposes and with authorized
              personnel.
            </p>
          </div>
        </section>
      </main>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Terms;
